import { Directive, inject, input } from '@angular/core';

import { AuthenticationService } from '../../auth/authentication/authentication.service';
import { BaseUrlService } from '../../auth/authentication/base-url.service';
import { authInfoTransformer } from '../../auth/awp/auth-info';
import { TracingService } from '../../backend/tracing.service';
import { I18nService } from '../i18n/services/i18n.service';
import { trackInput } from '../utils/signal/trackInput';

@Directive()
export class WebComponentDirective {
  // Services are injected as private fields so that they do not get in the way in subclasses
  readonly #authenticationService = inject(AuthenticationService);
  readonly #tracingService = inject(TracingService);
  readonly #baseUrlService = inject(BaseUrlService);

  readonly lang = input<string>();
  protected readonly propagateLang = trackInput(this.lang, inject(I18nService).languageFromInput);

  readonly authInfo = input(undefined, { transform: authInfoTransformer() });
  protected readonly propagateAuthInfo = trackInput(this.authInfo, this.#authenticationService.awpAuthInfoInput);

  readonly businessPartnerId = input<string>();
  protected readonly propagateBusinessPartnerId = trackInput(
    this.businessPartnerId,
    this.#authenticationService.awpBusinessPartnerIdInput,
  );

  readonly baseUrl = input<string>();
  protected readonly propagateBaseUrl = trackInput(this.baseUrl, this.#baseUrlService.baseUrlSetByInput);

  readonly cavorsSessionId = input<string | undefined>(undefined);
  protected readonly propagateCavorsSessionId = trackInput(
    this.cavorsSessionId,
    this.#tracingService.parentCavorsSessionId,
  );

  readonly oauthRedirectPath = input(undefined);
  protected readonly propagateOauthRedirectPath = trackInput(
    this.oauthRedirectPath,
    this.#authenticationService.oauthRedirectPath,
  );
}
